import React from "react";
import PermissionsForm from "./PermissionsForm";

// Alias wrapper so you can import either file name.
const AssignPermissions = () => {
  return <PermissionsForm />;
};

export default AssignPermissions;

